import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
export var useCarouselHeaderCollapsibleStyles = makeStyles({
    container: __assign(__assign(__assign(__assign(__assign({ alignItems: 'center' }, shorthands.borderRadius('2px')), { bottom: '0px', color: tokens.colorNeutralForeground1, columnGap: '4px', cursor: 'pointer', display: 'flex', height: '100%', marginLeft: '-27px' }), shorthands.outline(0)), shorthands.padding(0, '4px', 0, '4px')), { ':hover': {
            backgroundColor: tokens.colorNeutralBackground2Hover,
        }, ':focus-visible': {
            backgroundColor: tokens.colorNeutralBackground2,
            outlineColor: tokens.colorStrokeFocus2,
            outlineStyle: 'auto',
            outlineWidth: '1px',
        }, ':active': {
            backgroundColor: tokens.colorNeutralBackground2Pressed,
        }, ':disabled': {
            color: tokens.colorNeutralForegroundDisabled,
        } }),
    icon: __assign({ color: tokens.colorNeutralForeground1, float: 'left', alignSelf: 'center', flexShrink: 0 }, shorthands.margin('4px 4px 0px 0px')),
});
//# sourceMappingURL=CarouselHeaderCollapsible.styles.js.map